import styled from 'styled-components';

export const PageContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: #ffffff;
`;

export const DivisionCards = styled.div`
  @media (min-width: 930px) {
    padding-right: 150px;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
  }

  @media (max-width: 929px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const DivisionChangeName = styled.div`
  width: 100%;
  margin: 0rem 3rem 0 0;

  @media (max-width: 768px) {
    width: 100%;
    height: 100vh;
    margin: 0rem;
    background-color: white;
  }

  h3 {
    font-size: 1.1rem;
    color: #808080;
  }

  label {
    font-size: 1rem;
    color: #808080;
    margin-bottom: 0.2rem;
  }

  input {

    border-radius: 0.4rem;
    border: 0;
    padding: 0.91rem;

  }
`;

export const DivisionButton = styled.div`
  margin: 2rem 0 0 0rem;
  width: 20%;

  @media (max-width: 1700px) {
    width: 30%;
  }

  @media (max-width: 1400px) {
    width: 40%;
  }

  @media (max-width: 920px) {
    width: 50%;
  }

  @media (max-width: 770px) {
    margin: 2rem 0 0 0rem;
    width: 100%;
  }
`;

export const InsertName = styled.div`
  display: flex;
  flex-direction: column;
  margin: 3rem 0 0 0rem;
  width: 20%;

  @media (max-width: 1700px) {
    width: 30%;
  }

  @media (max-width: 1400px) {
    width: 40%;
  }

  @media (max-width: 920px) {
    width: 50%;
  }

  @media (max-width: 770px) {
    margin: 0rem 0 0 0rem;
    width: 100%;
  }

  input {
    border: 1px solid #b0b0b0;

    @media (max-width: 770px) {
      font-size: 0.85rem;
    }
  }
`;

export const BackIcon = styled.span`
  display: flex;
  justify-content: flex-end;
  margin: 0rem 3rem 1.5rem 0;
  cursor: pointer;

  @media (max-width: 1366px) {
    margin: 0 3rem 0 0;
  }

  @media (max-width: 770px) {
    margin: 1rem 1rem 1rem 0;
  }
`;

export const Content = styled.div`
  height: 75vh;
  padding: 0.5rem 2rem 2rem 2rem;
  margin: 0 0 0 3rem;
  overflow-y: scroll;

  @media (max-width: 400px) {
    padding: 0.5rem 1rem 2rem 1rem;
  }

  @media (max-width: 400px) {
    padding: 0.5rem 1rem 2rem 1rem;
  }

  @media (max-width: 770px) {
    margin: 0;
  }
`;

export const IconLoading = styled.i`
  font-size: 1.5rem;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;

  @media (max-width: 770px) {
    padding: 0;
    display: none;
  }
`;

export const HeaderMobileContainer = styled.div`
  width: 100%;
  background-color: white;

  @media (min-width: 770px) {
    padding: 0;
    display: none;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin: 1rem 0 0rem 0rem;

  @media (max-width: 1000px) {
    width: 100%;
  }
  @media (max-width: 768px) {
    margin-left: 0px;
    margin: 3rem 0 2rem 0rem;
  }
`;

export const ValeIcon = styled.img`
  width: 39px;
  height: 26px;
  margin-right: 20px;
`;

export const PageTitle = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const ModalErrorMessage = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #707070;
`;

export const ContainerTitle = styled.section`
  display: flex;
`;

export const ContentImage = styled.div`
  width: 5rem;
  height: 5rem;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const TitleInfo = styled.section`
  margin: 0 0 0 1rem;
  color: #707070;

  div {
    display: flex;
    flex-wrap: wrap;
    margin: 0.5rem 0 0.5rem 0;
  }

  h4 {
    font-size: 1.1rem;
    margin-right: 0.3rem;
  }

  a {
    color: #000fff;
    font-size: 0.91rem;

    @media (max-width: 350px) {
      font-size: 0.75rem;
    }
  }

  span {
    font-size: 0.91rem;

    @media (max-width: 350px) {
      font-size: 0.75rem;
    }
  }
`;

export const ContainerAvaliation = styled.section`
  margin: 2rem 0 0 0;

  a {
    color: #000fff !important;
    font-weight: 600 !important;
    text-decoration: underline !important;
    cursor: pointer !important;
  }

  h4 {
    font-size: 1.2rem;
    font-weight: 600;
    color: #707070;
  }

  @media (max-width: 929px) {
    padding-bottom: 50px;
  }
`;

export const StarDivision = styled.div`
  padding: 0rem 0 1rem 0;

  @media (min-width: 900px) {
    width: 30%;
  }

  @media (min-width: 770px) and (max-width: 900px) {
    width: 60%;
  }

  .MuiRating-root {
    font-size: 2.5rem;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    margin: 1rem 0rem 1rem -0.3rem;

    span {
      display: flex !important;
      justify-content: center !important;
    }

    .MuiRating-icon {
      display: flex !important;
      justify-content: center !important;
    }

    span.MuiRating-icon {
      display: flex !important;
      justify-content: center !important;
    }

    @media (max-width: 770px) {
      margin: 1rem 0rem;
    }
  }

  p {
    color: #5a5a5a;
    margin: 0 0 1rem 0;
    word-wrap: break-word;
  }

  h4 {
    color: #5a5a5a;
    font-weight: 550;
    font-size: 1rem;
    display: flex;
    justify-content: space-between;

    span {
      color: #9e9e9e;
      font-weight: 400;
      font-size: 0.8rem;
    }
  }
`;

export const ContainerVisit = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
`;

export const ContentVisit = styled.div`
  height: 95%;
  width: 100%;

  @media (max-width: 768px) {
    height: 100vh;
    width: 100%;
  }
`;

export const WrapperVisitTable = styled.div`
  height: 89%;
  width: 100%;

  @media (max-width: 770px) {
    margin-top: 0px;
  }
`;

export const PageTitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
  margin-bottom: 30px;
`;

export const PageTitleItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const PageTitleVisit = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const VisitMessage = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem 0 0 0;

  span {
    color: #808080;
  }
`;

export const VisitContainer = styled.div`
  width: 100%;
`;

export const DesktopWrapper = styled.div`
  width: 100vw;
  display: none;

  @media (min-width: 1000px) {
    display: initial;
  }
`;

export const MobileWrapper = styled.div`
  width: 100vw;
  display: none;

  @media (max-width: 1000px) {
    display: initial;
  }
`;

export const NextPageContainer = styled.div`
  display: flex;
  justify-content: ${(props) => props.content};
  margin-bottom: 1.5rem;
  color: #000FFF;
`;

export const NextPage = styled.span`
  color: #000FFF;
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
`;

export const ContentModal = styled.span`
  padding: 30px;
`;

export const CloseIcon = styled.div`
  display: flex;
  justify-content: flex-end;

  img {
    width: 6%;
    height: 6%;
    margin-top: -11%;
    cursor: pointer;

    @media(max-width: 770px) {
      width: 10%;
      height: 10%;
      margin-top: -17%;
    }
  }
`;

export const LabelModal = styled.div`
    padding-bottom: 5px;
    display: flex;
`;

export const LabelTitleModal = styled.div`
    padding-top: 15px;
    display: flex;
    font: normal normal 600 16px/20px Mangueira;
    color: #090909;
`;

export const StatusArea = styled.div`
    padding-left: 50px;
    display: flex;
    flex-direction: row;
    padding-bottom: 10px;
    padding-top: 10px;
`;

export const ObjectiveArea = styled.div`
    margin-top: 30px;
    padding-left: 50px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding-bottom: 10px;
    padding-top: 10px;
`;

export const CommentArea = styled.div`
    margin-top: 10px;
    margin-bottom: 60px;
    padding-left: 50px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding-bottom: 10px;
    padding-top: 10px;
`;

export const Legend = styled.div`
  font-size: 14px;
  color: #7f7f7f;
  margin-right: 6px;
`;

export const ItemDetails = styled.span`
  display: flex;
  color: #808080;
  font-size: 14px;
  font-weight: 300;
  margin-left: 27px;
  margin-right: 34px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

export const SelectLabel = styled.div`
    font: normal normal 600 12px Mangueira;
    color: #000000;
`;

export const Icon = styled.img`
    width: ${props => (props.hasWidth  ? props.hasWidth : '50px')};
    height: auto;
`;

export const ConsultantDataSection = styled.div`
  background-color: #FFFFFF;
  border: 1px solid #CBCBCB;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const SectionTitle = styled.h2`
  font-family: 'Mangueira';
  font-size: 24px;
  font-weight: 700;
  color: #3D3D3D;
  margin: 0 0 24px 0;
`;

export const ConsultantDataContainer = styled.div`
  display: flex;
  gap: 93px;
`;

export const ConsultantDataItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ConsultantIconContainer = styled.div`
  width: 48px;
  height: 48px;
  background-color: #EEF0FD;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ConsultantDataLabel = styled.div`
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 600;
  color: #CBCBCB;
  margin-bottom: 4px;
`;

export const ConsultantDataValue = styled.span`
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 700;
  color: #3D3D3D;
`;

export const VisitsHistorySection = styled.div`
  background-color: #FFFFFF;
  border: 1px solid #CBCBCB;
  border-radius: 16px;
  padding: 24px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  align-items: center;
`;

export const DateFilterContainer = styled.div`
  position: relative;
  width: 204px;
  height: 48px;
  border: 1px solid #CBCBCB;
  border-radius: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    border-color: #999;
  }
`;

export const DateInputDisplay = styled.div`
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 500;
  color: #3D3D3D;
  outline: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;

`;

export const HiddenDateInput = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  z-index: -1;
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
`;

export const DateIconContainer = styled.div`
  padding: 5px 10px 10px 10px;
  pointer-events: none;
`;

export const ClearDateButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #CBCBCB;
  font-size: 16px;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DropdownContainer = styled.div`
  position: relative;
`;

export const DropdownButton = styled.div`
  width: 204px;
  height: 48px;
  border: 1px solid #CBCBCB;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  background-color: #FFFFFF;
  cursor: pointer;
`;

export const DropdownButtonText = styled.span`
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 500;
  color: #3D3D3D;
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 204px;
  background-color: #FFFFFF;
  border: 1px solid #CBCBCB;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin-top: 4px;
`;

export const DropdownMenuItem = styled.div`
  padding: 12px;
  cursor: pointer;
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 400;
  color: #3D3D3D;
  background-color: ${props => props.isSelected ? '#F4F5FF' : 'transparent'};
  border-bottom: ${props => props.showBorder ? '1px solid #F0F0F0' : 'none'};

  &:hover {
    background-color: ${props => props.isSelected ? '#F4F5FF' : '#F8F9FA'};
  }
`;

export const StatusTabsContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
`;

export const StatusTab = styled.div`
  padding: 11px 16px;
  background-color: ${props => props.isSelected ? '#F4F5FF' : 'transparent'};
  border: ${props => props.isSelected ? '1px solid #0B29FB' : '1px solid #CBCBCB'};
  border-radius: ${props =>
    props.position === 'first' ? '5px 0 0 5px' :
    props.position === 'last' ? '0 5px 5px 0' : '0'
  };
  font-family: 'Mangueira';
  font-size: ${props => props.isSelected ? '16px' : '14px'};
  font-weight: 500;
  color: ${props => props.isSelected ? '#0B29FB' : '#3D3D3D'};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => props.isSelected ? '#F4F5FF' : '#F8F9FA'};
  }
`;

export const VisitsTable = styled.div`
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #CBCBCB;
`;

export const TableHeader = styled.div`
  display: flex;
  background-color: #FAFAFA;
  border-bottom: 1px solid #CBCBCB;
  border-radius: 10px 10px 0 0;
`;

export const TableHeaderCell = styled.div`
  width: ${props => props.width};
  padding: 11px 15px;
  font-family: 'Mangueira';
  font-size: 16px;
  font-weight: 700;
  color: #3D3D3D;
  text-align: ${props => props.textAlign || 'left'};
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const TableRow = styled.div`
  display: flex;
  border-bottom: ${props => props.showBorder ? '1px solid #CBCBCB' : 'none'};
  border-radius: ${props => props.isLast ? '0 0 12px 12px' : 'none'};
`;

export const TableCell = styled.div`
  width: ${props => props.width};
  padding: 11px 15px;
  display: flex;
  align-items: center;
  font-family: 'Mangueira';
  font-size: ${props => props.fontSize || '14px'};
  font-weight: ${props => props.fontWeight || '400'};
  color: ${props => props.color || '#636363'};
  white-space: ${props => props.whiteSpace || 'normal'};
  gap: ${props => props.gap || '0'};
  justify-content: ${props => props.justifyContent || 'flex-start'};
`;

export const StatusBadge = styled.div`
  background-color: ${props => {
    switch(props.status) {
      case 'Realizado': return '#EAF7EE';
      case 'Cancelado': return '#FCEDE9';
      case 'Agendada': return '#FFF3DC';
      default: return '#F0F0F0';
    }
  }};
  color: ${props => {
    switch(props.status) {
      case 'Realizado': return '#3DA464';
      case 'Cancelado': return '#E74141';
      case 'Agendada': return '#ED9500';
      default: return '#636363';
    }
  }};
  padding: 4px 8px;
  border-radius: 8px;
  font-family: 'Mangueira';
  font-size: 16px;
  font-weight: 500;
`;

export const RatingBadge = styled.div`
  background-color: #F0F0F0;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 12px;
  color: #3D3D3D;
  min-width: 29px;
  text-align: center;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

export const EmptyTableMessage = styled.div`
  padding: 40px;
  text-align: center;
  font-family: 'Mangueira';
  font-size: 14px;
  color: #636363;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
`;

export const PaginationLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const PaginationLabel = styled.span`
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 400;
  color: #3D3D3D;
`;

export const PaginationDropdown = styled.div`
  width: 68px;
  height: 44px;
  border: 1px solid #E1E2E3;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
  background-color: #FFFFFF;
  cursor: pointer;
`;

export const PaginationDropdownText = styled.span`
  font-family: 'Mangueira';
  font-size: 16px;
  font-weight: 400;
  color: #3D3D3D;
`;

export const PaginationRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const PaginationButton = styled.button`
  width: 44px;
  height: 44px;
  border: none;
  background: none;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.5 : 1};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PaginationCurrentPage = styled.div`
  width: 68px;
  height: 44px;
  border: 1px solid #E1E2E3;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  position: relative;
`;

export const PaginationCurrentPageText = styled.span`
  font-family: 'Mangueira';
  font-size: 16px;
  font-weight: 400;
  color: #3D3D3D;
`;

export const ConsultantDataValueContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const RatingStarsContainer = styled.div`
  display: flex;
  gap: 2px;
`;

export const RatingStarImage = styled.img`
  filter: ${props => props.isActive ? 'none' : 'grayscale(100%) brightness(0.9)'};
  opacity: ${props => props.opacity || 1};
  cursor: ${props => props.onClick ? 'pointer' : 'default'};
  transition: filter 0.2s ease;

  &:hover {
    filter: ${props => props.onClick ? 'none' : props.isActive ? 'none' : 'grayscale(100%) brightness(0.9)'};
  }
`;

export const RatingText = styled.span`
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 400;
  color: #0B29FB;
`;

export const WaitingText = styled.span`
  font-size: 14px;
  color: #636363;
`;

export const PaginationDropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 68px;
  background-color: #FFFFFF;
  border: 1px solid #E1E2E3;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin-top: 4px;
`;

export const PaginationDropdownItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  font-family: 'Mangueira';
  font-size: 16px;
  font-weight: 400;
  color: #3D3D3D;
  background-color: ${props => props.isSelected ? '#F4F5FF' : 'transparent'};
  border-bottom: ${props => props.showBorder ? '1px solid #F0F0F0' : 'none'};
  text-align: center;

  &:hover {
    background-color: ${props => props.isSelected ? '#F4F5FF' : '#F8F9FA'};
  }
`;

export const PaginationInfo = styled.span`
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 400;
  color: #3D3D3D;
`;

export const PaginationDropdownWrapper = styled.div`
  position: relative;
`;

export const VisitDetailsModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

export const LoadingDimOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.22);
  z-index: 999;
  cursor: wait;
`;

export const PageDimOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.28);
  z-index: 10001;
  cursor: wait;
`;

export const VisitDetailsModalContainer = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  padding: 24px;

  /* Esconder barra de rolagem */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */

  &::-webkit-scrollbar {
    display: none; /* Safari e Chrome */
  }
`;

export const VisitDetailsModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const VisitDetailsModalTitle = styled.h2`
  font-family: 'Mangueira';
  font-size: 20px;
  font-weight: 700;
  color: #3D3D3D;
  margin: 0;
`;

export const VisitDetailsCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #636363;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const VisitDetailsStatusBadge = styled.div`
  background-color: ${props => {
    switch(props.status) {
      case 'Realizado': return '#EAF7EE';
      case 'Cancelado': return '#FCEDE9';
      case 'Agendada': return '#FFF3DC';
      default: return '#F0F0F0';
    }
  }};
  color: ${props => {
    switch(props.status) {
      case 'Realizado': return '#3DA464';
      case 'Cancelado': return '#E74141';
      case 'Agendada': return '#ED9500';
      default: return '#636363';
    }
  }};
  padding: 4px 12px;
  border-radius: 16px;
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 20px;
`;

export const VisitDetailsRatingSection = styled.div`
  text-align: center;
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  background: white;
`;

export const VisitDetailsRatingNumber = styled.div`
  font-family: 'Mangueira';
  font-size: 32px;
  font-weight: 700;
  color: #3D3D3D;
  margin-bottom: 8px;
`;

export const VisitDetailsRatingStars = styled.div`
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-bottom: 8px;
`;

export const VisitDetailsRatingText = styled.div`
  font-family: 'Mangueira';
  font-size: 14px;
  color: #CBCBCB;
`;

export const VisitDetailsTagsContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  padding: 12px;
  background: white;
  border-radius: 6px;
`;

export const VisitDetailsTag = styled.span`
  background-color: #F0F0F0;
  color: #636363;
  padding: 6px 12px;
  border-radius: 16px;
  font-family: 'Mangueira';
  font-size: 12px;
  font-weight: 500;
`;

export const VisitDetailsDescription = styled.p`
  font-family: 'Mangueira';
  font-size: 14px;
  color: #636363;
  line-height: 1.5;
  margin-bottom: 24px;
  padding: 16px;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  background: white;
`;

export const VisitDetailsSection = styled.div`
  margin-bottom: 24px;
  padding: 16px;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  background: white;
`;

export const VisitDetailsSectionTitle = styled.h3`
  font-family: 'Mangueira';
  font-size: 16px;
  font-weight: 700;
  color: #3D3D3D;
  margin: 0 0 12px 0;
`;

export const VisitDetailsSummaryItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
`;

export const VisitDetailsSummaryIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
`;

export const VisitDetailsSummaryContent = styled.div`
  flex: 1;
`;

export const VisitDetailsSummaryLabel = styled.div`
  font-family: 'Mangueira';
  font-size: 12px;
  color: #636363;
  margin-bottom: 2px;
`;

export const VisitDetailsSummaryValue = styled.div`
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 500;
  color: #3D3D3D;
`;

export const InAnalysisModalContainer = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  padding: 24px;

  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */

  &::-webkit-scrollbar {
    display: none; /* Safari e Chrome */
  }
`;

export const InAnalysisStatusBadge = styled.div`
  background-color: #F3E5FF;
  color: #6703E1;
  padding: 4px 12px;
  border-radius: 16px;
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 20px;
`;

export const InAnalysisStatusBadgeOrange = styled.div`
  background-color: #FFF3DC;
  color: #ED9500;
  padding: 4px 12px;
  border-radius: 16px;
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 20px;
`;

export const InAnalysisInfoBox = styled.div`
  border: 2px solid #E5E5E5;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;

`;

export const InAnalysisIconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`;

export const InAnalysisMessage = styled.p`
  font-family: 'Mangueira';
  font-size: 14px;
  color: #636363;
  text-align: center;
  line-height: 1.5;
  margin: 0;
`;

export const ConfirmedStatusBadge = styled.div`
  background-color: #F8F2FF;
  color: #6703E1;
  padding: 4px 12px;
  border-radius: 16px;
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 20px;
`;

export const ConfirmedInfoBox = styled.div`
  border: 2px solid #CBCBCB;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  background-color: #FFFFFF;
`;

export const ConfirmedIconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`;

export const ConfirmedMessage = styled.p`
  font-family: 'Mangueira';
  font-size: 14px;
  color: #636363;
  text-align: center;
  line-height: 1.5;
  margin: 0;
`;

export const NotRealizedStatusBadge = styled.div`
  background-color: #FCEDE9;
  color: #E74141;
  padding: 4px 12px;
  border-radius: 16px;
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 20px;
`;

export const NotRealizedInfoBox = styled.div`
  border: 2px solid #E5E5E5;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const NotRealizedIconContainer = styled.div`
  margin-bottom: 16px;
`;

export const NotRealizedMessage = styled.p`
  font-family: 'Mangueira';
  font-size: 14px;
  color: #636363;
  line-height: 1.5;
  margin: 0 0 16px 0;
`;

export const RescheduleButton = styled.button`
  background-color: #3B82F6;
  color: #FFFFFF;
  border: 1px solid #3B82F6;
  border-radius: 6px;
  padding: 8px 16px;
  font-family: 'Mangueira';
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px auto;
  transition: all 0.2s ease;

  &:hover {
    background-color: #2563EB;
    border-color: #2563EB;
  }
`;

export const WhatHappenedSection = styled.div`
  border: 2px solid #E5E5E5;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
  background-color: #FFFFFF;
`;

export const WhatHappenedTitle = styled.h3`
  font-family: 'Mangueira';
  font-size: 16px;
  font-weight: 700;
  color: #3D3D3D;
  margin: 0 0 12px 0;
`;

export const WhatHappenedTextarea = styled.textarea`
  width: 100%;
  min-height: 80px;
  border: 1px solid #E1E2E3;
  border-radius: 6px;
  padding: 12px;
  font-family: 'Mangueira';
  font-size: 14px;
  color: #3D3D3D;
  resize: vertical;
  outline: none;

  &:focus {
    border-color: #3B82F6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
  }

  &::placeholder {
    color: #CBCBCB;
    font-family: 'Mangueira';
    font-size: 14px;
  }
`;

export const MobileVisitConfirmationDiv = styled.div`
  font-size: 14px;
  background-color: ${props => {
    switch(props.$confirmationStatus) {
      case 'Visita confirmada': return '#EAF7EE';
      case 'Visita não realizada': return '#FCEDE9';
      case 'Prazo expirado': return '#F0F0F0';
      default: return 'transparent';
    }
  }};
  color: ${props => {
    switch(props.$confirmationStatus) {
      case 'Visita confirmada': return '#3DA464';
      case 'Visita não realizada': return '#E74141';
      case 'Prazo expirado': return '#636363';
      default: return props.$isAgendado ? '#CBCBCB' : (props.$isConfirmar ? '#0B29FB' : '#636363');
    }
  }};
  font-weight: ${props => props.$isConfirmar ? 600 : 400};
  cursor: ${props => props.$isConfirmar ? 'pointer' : 'default'};
  margin-top: 4px;
  margin-bottom: 8px;
  padding: ${props => (props.$confirmationStatus === 'Visita confirmada' || props.$confirmationStatus === 'Visita não realizada' || props.$confirmationStatus === 'Prazo expirado') ? '4px 8px' : '0'};
  border-radius: ${props => (props.$confirmationStatus === 'Visita confirmada' || props.$confirmationStatus === 'Visita não realizada' || props.$confirmationStatus === 'Prazo expirado') ? '8px' : '0'};
`;

export const DesktopVisitConfirmationDiv = styled.div`
  background-color: ${props => {
    switch(props.$confirmationStatus) {
      case 'Visita confirmada': return '#EAF7EE';
      case 'Visita não realizada': return '#FCEDE9';
      case 'Prazo expirado': return '#F0F0F0';
      default: return 'transparent';
    }
  }};
  color: ${props => {
    switch(props.$confirmationStatus) {
      case 'Visita confirmada': return '#3DA464';
      case 'Visita não realizada': return '#E74141';
      case 'Prazo expirado': return '#636363';
      default: return props.$isAgendado ? '#CBCBCB' : (props.$isConfirmar ? '#0B29FB' : 'inherit');
    }
  }};
  font-weight: ${props => props.$isConfirmar ? 600 : 400};
  cursor: ${props => props.$isConfirmar ? 'pointer' : 'default'};
  padding: ${props => (props.$confirmationStatus === 'Visita confirmada' || props.$confirmationStatus === 'Visita não realizada' || props.$confirmationStatus === 'Prazo expirado') ? '4px 8px' : '0'};
  border-radius: ${props => (props.$confirmationStatus === 'Visita confirmada' || props.$confirmationStatus === 'Visita não realizada' || props.$confirmationStatus === 'Prazo expirado') ? '8px' : '0'};
`;

export const ConfirmarVisitaSpan = styled.span`
  cursor: pointer;
  color: #0B29FB;
  font-weight: 600;
`;

export const AvalieSpan = styled.span`
  cursor: pointer;
`;

export const MobileWaitingTextAdjusted = styled.span`
  position: relative;
  top: -10px;
  color: #636363;
`;

export const TableLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
`;

export const VisitsTableRelativeWrapper = styled.div`
  position: relative;
`;

export const MotivesSvgIcon = styled.svg`
  transform: ${props => props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: transform 0.2s ease;
`;

export const InfoIconButton = styled.button`
  background: none;
  border: none;
  color: #0066cc;
  cursor: pointer;
  font-size: 1.2rem;
  font-weight: bold;
  border-radius: 50%;
  height: 40px;
  padding: 40px 0px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const TooltipOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const TooltipModal = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.2s ease-out;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    max-width: 90vw;
    padding: 20px;
  }
`;

export const TooltipContent = styled.p`
  color: #333333;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;

export const HeaderCellContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderCellText = styled.span`
  font-weight: normal;
`;
